<template>
  <div
    class="images-group-1"
    :style="{...backgroundColor, ...shadow}"
  >
    <div class="d-inline-block position-relative">
      <slot />
    </div>
  </div>
</template>

<script>
import TemplateMixin from '../../../components/mixins/TemplateMixin'

export default {
  name: 'ImageItem1Template',
  mixins: [TemplateMixin]
}
</script>

<style lang="scss">
.images-group-1 {
  padding: 100px 60px;

  .img {
    border-radius: 3px;
    box-shadow: inset 0 0 0px 4px #ffffff;
  }


  .higliter:nth-child(1),
  .img-transform:nth-child(1) {
    .img-responsive-bg {
      width: 188px !important;
      min-height: 242px !important;
    }
  }

  .higliter:nth-child(3),
  .img-transform:nth-child(3){
    position: absolute;
    top: -10%;
    left: 90%;

    .img-responsive-bg {
      width: 155px !important;
      min-height: 182px !important;
    }
  }

  .higliter:nth-child(2),
  .img-transform:nth-child(2) {
    position: absolute;
    top: 50%;
    left: 70%;

    .img-responsive-bg {
      width: 155px !important;
      min-height: 182px !important;
    }
  }
}
</style>
